export const percentageToPos = (dimension: number, percentage: number) => {
  let res = dimension * percentage;
  return res;
};